import { AfterViewInit, Component, inject, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ClientData } from '../../../../shared/models/ClientData';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ToggleClassOnValueDirective } from 'app/shared/directives/toggle-class-on-value.directive';
import { environment } from '@env/environment';
import { SearchState } from '../../services/search.state';

@Component({
  selector: 'app-client-creation',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    ToggleClassOnValueDirective
  ],
  templateUrl: './client-creation.component.html',
  styleUrl: './client-creation.component.scss'
})
export class ClientCreationComponent implements AfterViewInit {
  readonly searchState = inject(SearchState);

  clientCreationForm: FormGroup;
  lstTenants = environment.tenants;
  formInvalid = signal<boolean>(true);

  constructor(
    public dialogRef: MatDialogRef<ClientCreationComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ClientData,
  ) {
    this.clientCreationForm = this.fb.group({
      tenant: [{}, [Validators.required]],
      document: ['', [
        Validators.required,
        Validators.pattern(/^\d{8,12}?$/)
      ]],
      firstName: ['', [
        Validators.required,
        Validators.pattern(/^([a-z]|[A-Z]|'|á|é|í|ó|ú|ñ|ü|Á|É|Í|Ó|Ú|Ñ|Ü|\s|\'|\-)+$/)
      ]],
      lastName: ['', [
        Validators.required,
        Validators.pattern(/^([a-z]|[A-Z]|'|á|é|í|ó|ú|ñ|ü|Á|É|Í|Ó|Ú|Ñ|Ü|\s|\'|\-)+$/)
      ]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\d{9}$/)]]
    });
  }

  ngAfterViewInit(): void {
    this.clientCreationForm.patchValue(this.data);
    this.clientCreationForm.valueChanges.subscribe(() => {
      this.formInvalid.set(!this.clientCreationForm.valid);
    });
  }

  async creationClient(): Promise<void> {
    if (this.clientCreationForm.invalid) return;

    try {
      await this.searchState.createClient(this.clientCreationForm.value);
      this.dialogRef.close('success');
    } catch (error) {
    }
  }

  get tenantControl() {
    return this.clientCreationForm.controls['tenant'];
  }
}
